import React, { useEffect, useRef } from 'react';

const CHARS = '∑∫λ∂∇σμβαπρ∞≈→∈≥≤ΔΩΦΨΓΛΠΣ+=÷×%#01EPANR';

export default function MatrixRain() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const fontSize = 14;
    let animFrame;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    let columns = Math.floor(canvas.width / fontSize);
    // Scatter drops randomly across full height on init so density is immediate
    const makeDrops = (cols, h) =>
      Array(cols).fill(0).map(() => Math.floor(Math.random() * (h / fontSize)));
    let drops = makeDrops(columns, canvas.height);

    const draw = () => {
      // Fade trail — dark semi-transparent overlay
      ctx.fillStyle = 'rgba(0,0,0,0.15)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      columns = Math.floor(canvas.width / fontSize);
      if (drops.length !== columns) {
        drops = makeDrops(columns, canvas.height);
        return;
      }

      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i++) {
        const y = drops[i] * fontSize;
        if (y < 0) { drops[i]++; continue; }

        // Bright white-green head
        ctx.fillStyle = '#ccffe0';
        ctx.fillText(CHARS[Math.floor(Math.random() * CHARS.length)], i * fontSize, y);

        // Green body characters drawn by the fade effect naturally
        // Occasionally draw an extra green char behind head
        if (drops[i] > 1) {
          ctx.fillStyle = '#00c832';
          ctx.fillText(CHARS[Math.floor(Math.random() * CHARS.length)], i * fontSize, y - fontSize);
        }

        // Reset with moderate stagger — shorter delay = more columns visible at once
        if (y > canvas.height) {
          drops[i] = -Math.floor(Math.random() * 20 + 5);
        }
        drops[i]++;
      }

    };

    // Throttle to ~18fps for slower feel
    let last = 0;
    const throttledDraw = (ts) => {
      if (ts - last > 75) { last = ts; draw(); }
      animFrame = requestAnimationFrame(throttledDraw);
    };

    // Small delay so canvas is sized before first draw
    const t = setTimeout(() => { animFrame = requestAnimationFrame(throttledDraw); }, 50);

    return () => {
      clearTimeout(t);
      cancelAnimationFrame(animFrame);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        pointerEvents: 'none',
        opacity: 0.2,
        display: 'block',
      }}
    />
  );
}
